import { render, staticRenderFns } from "./SelectableLoyaltyTierInput.vue?vue&type=template&id=f8853ac8&"
import script from "./SelectableLoyaltyTierInput.vue?vue&type=script&lang=js&"
export * from "./SelectableLoyaltyTierInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports